import { render, staticRenderFns } from "./ChatReplyQuote.vue?vue&type=template&id=dfca4dd8"
import script from "./ChatReplyQuote.vue?vue&type=script&lang=js"
export * from "./ChatReplyQuote.vue?vue&type=script&lang=js"
import style0 from "./ChatReplyQuote.vue?vue&type=style&index=0&id=dfca4dd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports